import React from "react";
import { bool } from "prop-types";

const VideoBlackIcon = ({ largeIcon }) =>
  largeIcon ? (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 72 72" id="video-blackbg">
      <circle fill="#121212" cx="36" cy="36" r="35" />
      <path
        id="Path_204"
        fill="#F1F1F1"
        d="M49.678,33.822l-18.8-11.2c-1.2-0.7-2.8-0.3-3.5,0.9c-0.2,0.4-0.4,0.9-0.4,1.3v22.3
c0,1.4,1.2,2.6,2.6,2.6c0.5,0,0.9-0.1,1.3-0.4l18.9-11.1c1.2-0.7,1.6-2.3,0.9-3.5C50.378,34.322,50.078,34.022,49.678,33.822
	L49.678,33.822z"
      />
    </svg>
  ) : (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 72 72" id="video-blackbg-rest">
      <circle fill="#121212" cx="36" cy="36" r="35" />
      <path
        id="Path_204"
        fill="#F1F1F1"
        d="M49.678,33.822l-18.8-11.2c-1.2-0.7-2.8-0.3-3.5,0.9c-0.2,0.4-0.4,0.9-0.4,1.3v22.3
c0,1.4,1.2,2.6,2.6,2.6c0.5,0,0.9-0.1,1.3-0.4l18.9-11.1c1.2-0.7,1.6-2.3,0.9-3.5C50.378,34.322,50.078,34.022,49.678,33.822
	L49.678,33.822z"
      />
    </svg>
  );

VideoBlackIcon.propTypes = {
  largeIcon: bool,
};

export default VideoBlackIcon;
